import * as React from "react";

interface SkeletonTableProps {
  rows?: number;
  columns?: number;
}

export function SkeletonTable({
  rows = 5,
  columns = 4,
}: SkeletonTableProps): React.JSX.Element {
  return (
    <table
      className="w-full border-collapse"
      aria-label="Загрузка данных"
      aria-busy="true"
    >
      <thead>
        <tr>
          {Array.from({ length: columns }).map((_, i) => (
            <th
              key={i}
              scope="col"
              className="h-10 px-4 text-left"
            >
              <div className="h-4 w-24 rounded bg-[var(--surface-2)] animate-pulse" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr
            key={rowIndex}
            className="border-t border-[var(--border)]"
          >
            {Array.from({ length: columns }).map((_, colIndex) => (
              <td key={colIndex} className="px-4 py-3">
                <div
                  className="h-4 rounded bg-[var(--surface-2)] animate-pulse"
                  style={{ width: `${60 + ((rowIndex * 3 + colIndex * 7) % 40)}%` }}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
